import React, { useEffect } from "react";
import LoadCSSforfirstTime from "../../../../CloudStorage/LoadCSSforfirstTime";
import CloudStorage from "../../../../CloudStorage/CloudStorage";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import SignRantContract from "./SignRantContract";
import {
  formatNumberWithCommas,
  getDateFormate,
  getDeadlineDate,
} from "../../AllDateTimeReleventFormate";
import { getRentalById, getRentalRequestById } from "../../../../redux/rental/action";
import ClientUserCommonDetails from "../../ClientUserCommonDetails";
import ContractView from "../../../CustomComponents/ContractView";
import { set } from "date-fns";

export default function RantContract() {
  const path = "Assets/scss/FindWork.module.scss";
  useEffect(() => {
    LoadCSSforfirstTime(path);
  }, [path]);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [pbi, setpbi] = React.useState("");
  const { id } = useParams();
  const location = useLocation();
  const { state } = location;

  const pbi1 = useSelector(
    ({ rental: { getrentalrequestbyid } }) => getrentalrequestbyid
  );
  const getrentalbyid = useSelector(
    ({ rental: { getrentalbyid } }) => getrentalbyid
  );
  useEffect(() => {
    dispatch(getRentalRequestById(id));
    dispatch(getRentalById(id));
  }, [id]);


  useEffect(() => {
    if (state?.approvefrom == "buyer") {
      setpbi(pbi1)
    }
    if (state?.approvefrom == "seller") {
      setpbi(pbi1)
    } else {
      setpbi(getrentalbyid)
    }
  }, [getrentalbyid, pbi1]);


  const formatDateString = (dateString) => {
    if (!dateString) return "";
    const dateObj = new Date(dateString);
    const options = {
      day: "numeric",
      month: "long",
      year: "numeric",
    };
    return dateObj.toLocaleDateString("en-US", options);
  };

  const formatTime = (time) => {
    if (!time) return "";
    const [hour, minutes] = time.split(":");
    const date = new Date();
    date.setHours(hour, minutes);
    return date.toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  };

  return (
    <div className="container-fluid contract">
      <div className="project-offer project-details col-lg-10 mx-auto">
        <p className="breadcrumbs">
          <a onClick={() => navigate(-2)}>TAI &gt; </a>
          <a onClick={() => navigate(-1)}>{pbi?.title || "Rental details"} &gt;</a> Contract
        </p>
        <div className="col-lg-10 mx-auto">
          <div className="contract-sec" id="capture-contract-section">
            <img
              src={`${CloudStorage.cloudurl}/Assets/Images/project/contract-logo.svg`}
              alt=""
            />
            <div className="flex-sec">
              <p>Date : {formatDateString(pbi?.created_on)}</p>
              <p>ID : {pbi?.id}</p>
            </div>
            <div className="website-design">
              <ContractView type={'rental_agreement'} />
            </div>
            <div className="project-details">
              <div className="flex-sec">
                <h5>Product Details</h5>
              </div>
              <div className="flex-sec flex-sec1">
                <p style={{ fontWeight: "600" }}>Total Cost</p>
                <p>SAR {(pbi?.rental_type == 2 || state?.payload?.rental_type == 2) ? formatNumberWithCommas(pbi?.total_price || state?.payload?.total_price) : formatNumberWithCommas(pbi?.total_price || state?.payload?.total_price)}</p>
              </div>
              <div className="flex-sec flex-sec1">
                <p style={{ fontWeight: "600" }}>Rental Type</p>
                <p>{(pbi?.rental_type == 2 || state?.payload?.rental_type == 2) ? 'Rental With Interpreter' : 'Rental Only'}</p>
              </div>
              <div className="flex-sec">
                <h6 style={{ fontWeight: "600" }}>Total Rental Duration (in UTC)</h6>
                {/* <p>
                  {pbi.duration}{" "}
                  {pbi?.duration_type == 1
                    ? "Hour"
                    : pbi?.duration_type == 2
                      ? "Days"
                      : pbi?.duration_type == 3
                        ? "Weeks"
                        : pbi?.duration_type == 4
                          ? "Months"
                          : ""}
                </p> */}
              </div>
              <div className="flex-sec flex-sec1">
                <p style={{ fontWeight: "600" }}>Start date & time</p>
                <p>{formatDateString(pbi?.start_date || state?.payload?.start_date)} {formatTime(pbi?.start_time || state?.payload?.start_time)}</p>
              </div>
              <div className="flex-sec flex-sec1">
                <p style={{ fontWeight: "600" }}>End date & time</p>
                <p>{formatDateString(pbi?.end_date || state?.payload?.end_date)} {formatTime(pbi?.end_time || state?.payload?.end_time)}</p>
              </div>



            </div>
            <ClientUserCommonDetails pbi={pbi} />
            <SignRantContract pbi={pbi} />
          </div>
        </div>
      </div>
    </div>
  );
}
